export default "__VITE_ASSET__5506d3dd__"